import React from 'react';
import {
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
} from 'react-router-dom';
import { useMedia } from 'react-use';

import {
  UserProfilePage,
  UserProfileSettingsPage,
  UserProfileCalendarsPage,
  UserProfileSubscriptionPage,
  UserProfileCommunitiesPage,
  NotificationsPage,
  SubscriptionInner,
  ChangePlanPage,
  EnterpriseCheckoutPage,
  CancelSubscriptionPage,
  UserProfileEvents,
  PersonalChat,
} from 'pages';
import { ROUTES, PROFILE_ROUTES } from 'configs';
import { breakpoints } from 'theme';
import { ProfileSidebarMobile, ProfileMenu } from 'components';

/** Legacy `/profile/subscription/plans/:id` → canonical checkout URL. */
const SubscriptionPlansToChangePlanCheckoutRedirect = () => {
  const { subscriptionId } = useParams<{ subscriptionId: string }>();
  const location = useLocation();
  return (
    <Navigate
      to={`${ROUTES.PROFILE}/${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.CHANGE_PLAN}/${subscriptionId}${location.search}`}
      replace
      state={location.state}
    />
  );
};

/** Legacy `/profile/subscription/plans` → plan selection. */
const SubscriptionPlansListingRedirect = () => (
  <Navigate
    to={`${ROUTES.PROFILE}/${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.CHANGE_PLAN}`}
    replace
  />
);

const ProfileRouter = () => {
  const isWide = useMedia(breakpoints.md);

  return (
    <>
      {isWide ? <ProfileMenu /> : <ProfileSidebarMobile />}
      <Routes>
        <Route index element={<UserProfilePage />} />
        <Route
          path={PROFILE_ROUTES.SETTINGS}
          element={<UserProfileSettingsPage />}
        />

        <Route
          path={PROFILE_ROUTES.CALENDAR_CONNECTION}
          element={<UserProfileCalendarsPage />}
        />

        <Route
          path={`${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.ENTERPRISE_CHECKOUT}`}
          element={<EnterpriseCheckoutPage />}
        />

        <Route
          path={`${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.CANCEL_SUBSCRIPTION}`}
          element={<CancelSubscriptionPage />}
        />

        <Route
          path={`${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.CHANGE_PLAN}/:subscriptionId`}
          element={<SubscriptionInner />}
        />

        <Route
          path={`${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.CHANGE_PLAN}`}
          element={<ChangePlanPage />}
        />

        <Route
          path={`${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.PLANS}/:subscriptionId`}
          element={<SubscriptionPlansToChangePlanCheckoutRedirect />}
        />

        <Route
          path={`${PROFILE_ROUTES.SUBSCRIPTION}/${PROFILE_ROUTES.PLANS}`}
          element={<SubscriptionPlansListingRedirect />}
        />

        <Route
          path={PROFILE_ROUTES.SUBSCRIPTION}
          element={<UserProfileSubscriptionPage />}
        />

        <Route
          path={PROFILE_ROUTES.COMMUNITIES}
          element={<UserProfileCommunitiesPage />}
        />

        <Route path={ROUTES.EVENTS} element={<UserProfileEvents />} />

        <Route
          path={PROFILE_ROUTES.NOTIFICATIONS}
          element={<NotificationsPage />}
        />
        <Route path={PROFILE_ROUTES.CHAT} element={<PersonalChat />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
        {/* <Route
          path={`${ROUTES.MESSAGE}/:userId`}
          element={<PrivateChatPage />}
        /> */}
      </Routes>
    </>
  );
};

export default ProfileRouter;
